import { apiRequest, apiRequestPublic } from "./service";
import { FAMILY_MEMBER_REQUEST, FAMILY_MEMBER_REQUEST_RESPOND, FAMILY_MEMBERS, FAMILY_MEMBER_INCOMING_REQUESTS, FAMILY_MEMBER_SENT_REQUESTS, FAMILY_MEMBER_REMOVE, FAMILY_MEMBER_DATA, ADD_ALLERGY, ADD_BLOOD_OXYGEN, ADD_BLOOD_PRESSURE, ADD_BLOOD_SUGAR, ADD_BODY_TEMPERATURE, ADD_HEALTH_CONDITIONS, ADD_HEART_RATE, ADD_LIPID_PROFILE, ADD_MEDICAL_REPORT, ADD_MEDICATIONS, ADD_RESPIRATORY_RATE, ADD_SURGURIES, ADD_VACCINATIONS, BILLING_INVOICE, BILLING_INVOICE_DETAIL, CREATE_APPOINTMENT, DEL_ALLERGY, DEL_HEALTH_CONDITIONS, DEL_MEDICAL_REPORT, DEL_MEDICATIONS, DEL_SURGURIES, DEL_VACCINATIONS, GET_ALLERGY, GET_APPOINTMENT_FOR_DOCTOR, GET_BLOOD_PRESSURE, GET_BLOOD_SUGAR, GET_BODY_TEMPERATURE, GET_DOCTOR_BLOOD_PRESSURE, GET_DOCTOR_BLOOD_SUGAR, GET_DOCTOR_BODY_TEMPERATURE, GET_DOCTOR_HEALTH_PARAMS, GET_DOCTOR_HEART_RATE, GET_DOCTOR_LIPID_DATA, GET_DOCTOR_AVAILABLE_TIME, GET_DOCTOR_LIST, GET_DOCTOR_OXYGEN, GET_DOCTOR_RESPIRATORY_RATE, GET_HEALTH_CONDITIONS, GET_HEALTH_PARAMS, GET_HEART_RATE, GET_LATEST_ECG, GET_LIPID_DATA, GET_MEDICAL_REPORT, GET_MEDICATIONS, GET_OXYGEN, GET_PATIENT_DETAILS_FOR_DOCTOR, GET_PATIENT_PREVIOUS_APPOINTMENTS_FOR_DOCTOR, GET_PATIENT_APPOINTMENT_LIST, GET_RESPIRATORY_RATE, GET_SURGURIES, GET_VACCINATIONS, QRCODE, QRPATIENTINFO, SLOTS, UPDATE_ALLERGY, UPDATE_HEALTH_CONDITIONS, UPDATE_MEDICATIONS, UPDATE_SURGURIES, UPDATE_VACCINATIONS, getUriWithDurationAndDateFormat, GET_MEDICAL_DETAILS_BY_DOCTOR, GET_PATIENT_MEDICAL_REPORT, DOCTOR_ADD_SLOT, GET_SLOT_BY_DOCTOR, DELETE_SLOT_BY_DOCTOR, GET_CURRENCY, SEND_MEDICATION_BY_DOCTOR, CANCEL_APPOINTMENT_BY_PATIENT, CONFIRM_APPOINTMENT_BY_DOCTOR, GET_PATIENT_EPRESCRIPTION, GET_MEDICAL_DETAILS_BY_PATIENT, PATIENT_CHECKOUT, GET_PROFILE_BY_DOCTOR, UPDATE_PROFILE_BY_DOCTOR, GET_PATIENT_PRESCRIPTION_BY_DOCTOR, BILLING_INVOICE_FOR_DOCTOR, ORGANIZATION_GET_APPOINTMENTLIST, GET_ORGANIZATION_HEALTH_PARAMS, GET_PATIENT_DETAILS_FOR_ORGANIZATION, GET_ORGANIZATION_LIPID_PROFILE, GET_MEDICAL_DETAILS_FOR_ORGANIZATION, GET_MEDICAL_REPORTS_FOR_ORGANIZATION, GET_EPRESCIPTION_FOR_ORGANIZATION, GET_PATIENT_PREVIOUS_APPOINTMENTS_FOR_ORGANIZATION, GET_PATIENT_BLOOD_SUGAR_ORGANIZATION, GET_PATIENT_OXYGEN_ORGANIZATION, GET_PATIENT_BLOOD_PRESSURE_ORGANIZATION, GET_PATIENT_BODY_TEMPERATURE_ORGANIZATION, GET_PATIENT_HEART_RATE_ORGANIZATION, GET_PATIENT_RESPIRATORY_RATE_ORGANIZATION, GET_PATIENT_LIST, GET_DOCTOR_LIST_FOR_ORGANIZATION, ADD_DOCTOR, ADD_SUBADMIN, GET_ORGANIZATION_PROFILE, UPDATE_PROFILE_BY_ORGANIZATION, GET_SUBADMIN_LIST, GET_INVOICES_BY_ORGANIZATION, ADD_PATIENT_BY_FORM, ADD_PATIENT_BY_ID, GET_PROFILE_BY_SUBADMIN, GET_OPD_APPOINTMENTLIST_BY_SUBADMIN, GET_INVOICES_BY_SUBADMIN, GET_PATIENT_DETAILS_FOR_SUBADMIN, GET_SUBADMIN_HEALTH_PARAMS, GET_SUBADMIN_LIPID_PROFILE, GET_PATIENT_BLOOD_SUGAR_SUBADMIN, GET_PATIENT_OXYGEN_SUBADMIN, GET_PATIENT_BLOOD_PRESSURE_SUBADMIN, GET_PATIENT_BODY_TEMPERATURE_SUBADMIN, GET_PATIENT_HEART_RATE_SUBADMIN, GET_PATIENT_RESPIRATORY_RATE_SUBADMIN, GET_MEDICAL_DETAILS_FOR_SUBADMIN, GET_MEDICAL_REPORTS_FOR_SUBADMIN, GET_PATIENT_PREVIOUS_APPOINTMENTS_FOR_SUBADMIN, GET_PATIENT_LIST_BY_SUBADMIN, GET_DOCTOR_LIST_FOR_SUBADMIN, GET_EPRESCRIPTION_FOR_SUBADMIN, SLOTS_BY_SUBADMIN, CREATE_APPOINTMENT_BY_SUBADMIN, GET_ROOMS, ADD_ROOM, UPDATE_ROOM, ADD_PATIENT_BY_SUBADMIN, ADMIT_PATIENT, ADD_PATIENT_SERVICE, GET_ADMITTED_PATIENT, GET_ADMITTED_PATIENT_SERVICE, VERIFY_PAYMENT_PATIENT, GET_DOCTOR_DETAILS_FOR_ORGANIZATION, GET_SUBADMIN_DETAILS_FOR_ORGANIZATION, ORGANIZATION_SUBSCRIPTION_API, VERIFY_PAYMENT_ORGANIZATION, VERIFY_PAYMENT_SUBADMIN, ORGANIZATION_SUBADMIN_UPDATE_STATUS, ORGANIZATION_DOCTOR_UPDATE_STATUS, ORGANIZATION_REMOVE_PATIENT, ORGANIZATION_GET_SUBCRIPTION, GET_PATIENT_PROFILE, REQUEST_DELETE_PATIENT, VERIFY_DELETE_PATIENT, DELETE_HEALTH_PARAMS, DEL_MULTIPLE_MEDICAL_REPORTS, GET_RECOMMENDATIONS, GET_SCANNED_REPORTS, ANALYZE_REPORT, GET_ABNORMAL_REPORTS, GET_MEDICINE_LIST_FOR_DOCTOR, GET_BLOOD_COUGH_IMAGE, GET_ABNORMAL_REPORTS_BY_DOCTOR, GET_ABNORMAL_REPORTS_BY_SUBADMIN, getUser, GET_ABNORMAL_REPORTS_BY_ORG, GET_STEPS_DATA, GET_ALL_ECG_BY_DATE, GET_DOCTOR_PATIENT_ECG_BY_DATE, GET_DOCTOR_PATIENT_LAST_ECG, GET_SLEEP_DATA, GET_DOCTOR_STEPS, GET_PATIENT_STEPS_BY_DOCTOR, COMPLETE_APPOINTMENT_BY_DOCTOR } from "./apiUrl";

export const bloodSugarAPI = (payload) => {
  const user = getUser();
  let URL = user === 'patient' ?
    `${getUriWithDurationAndDateFormat(GET_BLOOD_SUGAR(), payload?.duration?.toLowerCase(), payload?.date)}` : user === 'doctor' ?
      `${GET_DOCTOR_BLOOD_SUGAR}&appointmentId=${payload.appointmentId}&duration=${payload?.duration?.toLowerCase() || 'w'}&date=${payload?.date}` : user === 'organization' ?
        `${GET_PATIENT_BLOOD_SUGAR_ORGANIZATION}&patientId=${payload.patientId}&duration=${payload?.duration?.toLowerCase() || 'w'}&date=${payload?.date}` :
        `${GET_PATIENT_BLOOD_SUGAR_SUBADMIN}&patientId=${payload.patientId}&duration=${payload?.duration?.toLowerCase() || 'w'}&date=${payload?.date}`;

  // Add ai_analysis parameter if present
  if (payload.ai_analysis) {
    URL += `&ai_analysis=${payload.ai_analysis}`;
  }

  return apiRequest({
    apiUrl: URL,
    method: "GET",
    token: payload.token,
  });
};

export const healthParamsAPI = (payload) => {
  const user = getUser();
  let URL = user === 'patient' ?
    `${getUriWithDurationAndDateFormat(GET_HEALTH_PARAMS(), payload?.duration?.toLowerCase(), payload?.date)}` : user === 'doctor' ?
      `${GET_DOCTOR_HEALTH_PARAMS}&appointmentId=${payload?.appointmentId}&duration=${payload?.duration?.toLowerCase()}&date=${payload?.date}` : user === 'organization' ?
        `${GET_ORGANIZATION_HEALTH_PARAMS}&patientId=${payload?.patientId}&duration=${payload?.duration?.toLowerCase()}&date=${payload?.date}` :
        `${GET_SUBADMIN_HEALTH_PARAMS}&patientId=${payload?.patientId}&duration=${payload?.duration?.toLowerCase()}&date=${payload?.date}`;

  // Add ai_analysis parameter if present
  if (payload?.ai_analysis) {
    URL += `&ai_analysis=${payload.ai_analysis}`;
  }

  return apiRequest({
    apiUrl: URL,
    method: "GET",
    token: payload.token,

  });
};

export const bloodPressureAPI = (payload) => {
  const user = getUser();
  let URL = user === 'patient' ?
    `${getUriWithDurationAndDateFormat(GET_BLOOD_PRESSURE(), payload?.duration?.toLowerCase(), payload?.date)}` : user === 'doctor' ?
      `${GET_DOCTOR_BLOOD_PRESSURE}&appointmentId=${payload.appointmentId}&duration=${payload?.duration?.toLowerCase() || 'w'}&date=${payload?.date}` : user === 'organization' ?
        `${GET_PATIENT_BLOOD_PRESSURE_ORGANIZATION}&patientId=${payload.patientId}&duration=${payload?.duration?.toLowerCase() || 'w'}&date=${payload?.date}` :
        `${GET_PATIENT_BLOOD_PRESSURE_SUBADMIN}&patientId=${payload.patientId}&duration=${payload?.duration?.toLowerCase() || 'w'}&date=${payload?.date}`;

  // Add ai_analysis parameter if present
  if (payload.ai_analysis) {
    URL += `&ai_analysis=${payload.ai_analysis}`;
  }

  console.log('URL_______', URL);
  return apiRequest({
    apiUrl: URL,
    method: "GET",
    token: payload.token,
  });
}

export const bloodOxygenAPI = (payload) => {
  const user = getUser();
  let URL = user === 'patient' ?
    `${getUriWithDurationAndDateFormat(GET_OXYGEN(), payload?.duration?.toLowerCase(), payload?.date)}` : user === 'doctor' ?
      `${GET_DOCTOR_OXYGEN}&appointmentId=${payload.appointmentId}&duration=${payload?.duration?.toLowerCase() || 'w'}&date=${payload?.date}` : user === 'organization' ?
        `${GET_PATIENT_OXYGEN_ORGANIZATION}&patientId=${payload.patientId}&duration=${payload?.duration?.toLowerCase() || 'w'}&date=${payload?.date}` :
        `${GET_PATIENT_OXYGEN_SUBADMIN}&patientId=${payload.patientId}&duration=${payload?.duration?.toLowerCase() || 'w'}&date=${payload?.date}`
    ;

  // Add ai_analysis parameter if present
  if (payload.ai_analysis) {
    URL += `&ai_analysis=${payload.ai_analysis}`;
  }

  return apiRequest({
    apiUrl: URL,
    method: "GET",
    token: payload.token,
  });
}

export const bodyTempAPI = (payload) => {
  const user = getUser();
  let URL = user === 'patient' ?
    `${getUriWithDurationAndDateFormat(GET_BODY_TEMPERATURE(), payload?.duration?.toLowerCase(), payload?.date)}` : user === 'doctor' ?
      `${GET_DOCTOR_BODY_TEMPERATURE}&appointmentId=${payload.appointmentId}&duration=${payload?.duration?.toLowerCase() || 'w'}&date=${payload?.date}` : user === 'organization' ?
        `${GET_PATIENT_BODY_TEMPERATURE_ORGANIZATION}&patientId=${payload.patientId}&duration=${payload?.duration?.toLowerCase() || 'w'}&date=${payload?.date}` :
        `${GET_PATIENT_BODY_TEMPERATURE_SUBADMIN}&patientId=${payload.patientId}&duration=${payload?.duration?.toLowerCase() || 'w'}&date=${payload?.date}`;

  // Add ai_analysis parameter if present
  if (payload.ai_analysis) {
    URL += `&ai_analysis=${payload.ai_analysis}`;
  }

  return apiRequest({
    apiUrl: URL,
    method: "GET",
    token: payload.token,
  });
}
export const getPatientProfileUpdate = (payload) => {

  return apiRequest({
    apiUrl: GET_PATIENT_PROFILE(),
    method: "GET",
    token: payload.token
  })
}
export const heartRateAPI = (payload) => {
  const user = getUser();
  let URL = user === 'patient' ?
    `${getUriWithDurationAndDateFormat(GET_HEART_RATE(), payload?.duration?.toLowerCase(), payload?.date)}` : user === 'doctor' ?
      `${GET_DOCTOR_HEART_RATE}&appointmentId=${payload.appointmentId}&duration=${payload?.duration?.toLowerCase() || 'w'}&date=${payload?.date}` : user === 'organization' ?
        `${GET_PATIENT_HEART_RATE_ORGANIZATION}&patientId=${payload.patientId}&duration=${payload?.duration?.toLowerCase() || 'w'}&date=${payload?.date}` :
        `${GET_PATIENT_HEART_RATE_SUBADMIN}&patientId=${payload.patientId}&duration=${payload?.duration?.toLowerCase() || 'w'}&date=${payload?.date}`;

  // Add ai_analysis parameter if present
  if (payload.ai_analysis) {
    URL += `&ai_analysis=${payload.ai_analysis}`;
  }

  return apiRequest({
    apiUrl: URL,
    method: "GET",
    token: payload.token,
  });
}

export const respiratoryRateAPI = (payload) => {
  const user = getUser();
  let URL = user === 'patient' ?
    `${getUriWithDurationAndDateFormat(GET_RESPIRATORY_RATE(), payload?.duration?.toLowerCase(), payload?.date)}` : user === 'doctor' ?
      `${GET_DOCTOR_RESPIRATORY_RATE}&appointmentId=${payload.appointmentId}&duration=${payload?.duration?.toLowerCase() || 'w'}&date=${payload?.date}` : user === 'organization' ?
        `${GET_PATIENT_RESPIRATORY_RATE_ORGANIZATION}&patientId=${payload.patientId}&duration=${payload?.duration?.toLowerCase() || 'w'}&date=${payload?.date}` :
        `${GET_PATIENT_RESPIRATORY_RATE_SUBADMIN}&patientId=${payload.patientId}&duration=${payload?.duration?.toLowerCase() || 'w'}&date=${payload?.date}`
    ;

  // Add ai_analysis parameter if present
  if (payload.ai_analysis) {
    URL += `&ai_analysis=${payload.ai_analysis}`;
  }

  return apiRequest({
    apiUrl: URL,
    method: "GET",
    token: payload.token,
  });
}

export const stepsDataAPI = (payload) => {
  const user = getUser();
  let URL = user === 'patient' ?
    `${getUriWithDurationAndDateFormat(GET_STEPS_DATA(), payload?.duration?.toLowerCase(), payload?.date)}` : user === 'doctor' ?
      `${GET_DOCTOR_STEPS}&appointmentId=${payload.appointmentId}&duration=${payload?.duration?.toLowerCase() || 'w'}&date=${payload?.date}` :
      // : user === 'organization' ?
      //   `${GET_PATIENT_STEPS_ORGANIZATION}&patientId=${payload.patientId}&duration=${payload?.duration?.toLowerCase() || 'w'}&date=${payload?.date}` :
      //   `${GET_PATIENT_STEPS_SUBADMIN}&patientId=${payload.patientId}&duration=${payload?.duration?.toLowerCase() || 'w'}&date=${payload?.date}`;
      `${getUriWithDurationAndDateFormat(GET_STEPS_DATA(), payload?.duration?.toLowerCase(), payload?.date)}`;

  if (payload.ai_analysis) {
    URL += `&ai_analysis=${payload.ai_analysis}`;
  }

  return apiRequest({
    apiUrl: URL,
    method: "GET",
    token: payload.token,
  });
};

// export const sleepDataAPI = (payload) => {
//   const URL = `${getUriWithDurationAndDateFormat(GET_SLEEP_DATA(), payload?.duration?.toLowerCase(), payload.date)}`;
//   return apiRequest({ apiUrl: URL, method: "GET", token: payload.token });
// };

export const lipidProfileApi = (payload) => {
  const user = getUser();
  let url = user === 'patient' ? GET_LIPID_DATA() :
    user === 'doctor' ? `${GET_DOCTOR_LIPID_DATA}&appointmentId=${payload.appointmentId}` : user === 'organization' ?
      `${GET_ORGANIZATION_LIPID_PROFILE}&patientId=${payload.patientId}&duration=${payload?.duration?.toLowerCase()}&date=${payload?.date}` :
      `${GET_SUBADMIN_LIPID_PROFILE}&patientId=${payload.patientId}&duration=${payload?.duration?.toLowerCase()}&date=${payload?.date}`
  return apiRequest({
    apiUrl: url,
    method: "GET",
    token: payload.token
  })
}

export const deleteHealthParamsAPI = (payload) => {
  const tempUrl =
    `${getUriWithDurationAndDateFormat(DELETE_HEALTH_PARAMS(), payload?.duration?.toLowerCase(), payload.date)}`;
  const URL = `${tempUrl}&type=${payload.type}`;
  console.log('URL____', URL);
  return apiRequest({
    apiUrl: URL,
    method: "DELETE",
    token: payload.token,
  });
};

export const addRespiratoryRateApi = (payload) => {
  const { token, ...rest } = payload;
  return apiRequest({
    apiUrl: ADD_RESPIRATORY_RATE(),
    method: "POST",
    token: payload.token,
    payload: rest
  })
}

export const addBloodPressureApi = (payload) => {
  const { token, ...rest } = payload;
  return apiRequest({
    apiUrl: ADD_BLOOD_PRESSURE(),
    method: "POST",
    token: payload.token,
    payload: rest
  })
}

export const addBloodSugarApi = (payload) => {
  const { token, ...rest } = payload;
  return apiRequest({
    apiUrl: ADD_BLOOD_SUGAR(),
    method: "POST",
    token: payload.token,
    payload: rest
  })
}

export const addBloodOxygenApi = (payload) => {
  const { token, ...rest } = payload;
  return apiRequest({
    apiUrl: ADD_BLOOD_OXYGEN(),
    method: "POST",
    token: payload.token,
    payload: rest
  })
}

export const addBodyTemperatureApi = (payload) => {
  const { token, ...rest } = payload;
  return apiRequest({
    apiUrl: ADD_BODY_TEMPERATURE(),
    method: "POST",
    token: payload.token,
    payload: rest
  })
}

export const addHeartRateApi = (payload) => {
  const { token, ...rest } = payload;
  return apiRequest({
    apiUrl: ADD_HEART_RATE(),
    method: "POST",
    token: payload.token,
    payload: rest
  })
}

export const addLipidProfileApi = (payload) => {
  const { token, ...rest } = payload;
  return apiRequest({
    apiUrl: ADD_LIPID_PROFILE(),
    method: "POST",
    token: payload.token,
    payload: rest.values
  })
}

export const addMedicalReport = (payload) => {
  const { token, ...rest } = payload;
  return apiRequest({
    apiUrl: ADD_MEDICAL_REPORT(),
    method: "POST",
    token: payload.token,
    payload: rest.values
  })
}

export const getMedicalReport = (payload) => {
  const user = getUser();
  let url = user === 'patient' ? GET_MEDICAL_REPORT() :
    user === 'doctor' ? `${GET_PATIENT_MEDICAL_REPORT}&date=${payload.date}&appointmentId=${payload.appointmentId}` :
      user === 'organization' ? `${GET_MEDICAL_REPORTS_FOR_ORGANIZATION}&date=${payload.date}&patientId=${payload.patientId}` :
        `${GET_MEDICAL_REPORTS_FOR_SUBADMIN}&date=${payload.date}&patientId=${payload.patientId}`;
  return apiRequest({
    apiUrl: url,
    method: "GET",
    token: payload.token,
  });
}

export const getPatientPrescriptionApi = (payload) => {
  const user = getUser();
  let url = user === 'patient' ? GET_PATIENT_EPRESCRIPTION :
    user === 'doctor' ? `${GET_PATIENT_PRESCRIPTION_BY_DOCTOR}&appointmentId=${payload.appointmentId}&date=${payload.date}` :
      user === 'organization' ? `${GET_EPRESCIPTION_FOR_ORGANIZATION}&patientId=${payload.patientId}&date=${payload.date}` :
        `${GET_EPRESCRIPTION_FOR_SUBADMIN}&patientId=${payload.patientId}&date=${payload.date}`
  return apiRequest({
    apiUrl: url,
    method: "GET",
    token: payload.token,
  })
};

// export const getPatientMedicalReportApi = (payload) => {
//   let url = `${GET_PATIENT_MEDICAL_REPORT}&appointmentId=${payload.appointmentId}&date=${payload.date}`;
//   return apiRequest({
//     apiUrl: url,
//     method: "GET",
//     token: payload.token,
//   })
// }

export const deleteMedicalReport = (payload) => {
  const { token, id } = payload;
  return apiRequest({
    apiUrl: `${DEL_MEDICAL_REPORT()}/${id}`,
    method: "DELETE",
    token
  })
}

export const deleteMultipleMedicalReports = (payload) => {
  const { token, ids } = payload;
  return apiRequest({
    apiUrl: `${DEL_MULTIPLE_MEDICAL_REPORTS()}`,
    method: "DELETE",
    payload: { ids },
    token,
  })
}

// health conditions apis
export const addHealthCondition = (payload) => {
  const { token, ...rest } = payload;
  return apiRequest({
    apiUrl: ADD_HEALTH_CONDITIONS(),
    method: "POST",
    token: payload.token,
    payload: rest.values
  })
}

export const updateHealthCondition = (id, payload) => {
  const { token, ...rest } = payload;
  return apiRequest({
    apiUrl: `${UPDATE_HEALTH_CONDITIONS()}/${id}`,
    method: "PUT",
    token: payload.token,
    payload: rest.values
  })
}

export const getHealthCondition = (payload) =>
  apiRequest({
    apiUrl: GET_HEALTH_CONDITIONS(),
    method: "GET",
    token: payload.token,
  });


export const deleteHealthCondition = (payload) => {
  const { token, id } = payload;
  return apiRequest({
    apiUrl: `${DEL_HEALTH_CONDITIONS()}/${id}`,
    method: "DELETE",
    token
  })
}

// medications apis
export const addMedication = (payload) => {
  const { token, ...rest } = payload;
  return apiRequest({
    apiUrl: ADD_MEDICATIONS(),
    method: "POST",
    token: payload.token,
    payload: rest.values
  })
}

export const updateMeications = (id, payload) => {
  const { token, ...rest } = payload;
  return apiRequest({
    apiUrl: `${UPDATE_MEDICATIONS()}/${id}`,
    method: "PUT",
    token: payload.token,
    payload: rest.values
  })
}

export const getMedication = (payload) =>
  apiRequest({
    apiUrl: GET_MEDICATIONS(),
    method: "GET",
    token: payload.token,
  });


export const deleteMedication = (payload) => {
  const { token, id } = payload;
  return apiRequest({
    apiUrl: `${DEL_MEDICATIONS()}/${id}`,
    method: "DELETE",
    token
  })
}

// surguries apis
export const addSurgury = (payload) => {
  const { token, ...rest } = payload;
  return apiRequest({
    apiUrl: ADD_SURGURIES(),
    method: "POST",
    token: payload.token,
    payload: rest.values
  })
}

export const updateSurgury = (id, payload) => {
  const { token, ...rest } = payload;
  return apiRequest({
    apiUrl: `${UPDATE_SURGURIES()}/${id}`,
    method: "PUT",
    token: payload.token,
    payload: rest.values
  })
}

export const getSurgury = (payload) =>
  apiRequest({
    apiUrl: GET_SURGURIES(),
    method: "GET",
    token: payload.token,
  });


export const deleteSurgury = (payload) => {
  const { token, id } = payload;
  return apiRequest({
    apiUrl: `${DEL_SURGURIES()}/${id}`,
    method: "DELETE",
    token
  })
}


// allergies apis
export const addAllergy = (payload) => {
  const { token, ...rest } = payload;
  return apiRequest({
    apiUrl: ADD_ALLERGY(),
    method: "POST",
    token: payload.token,
    payload: rest.values
  })
}

export const updateAllergy = (id, payload) => {
  const { token, ...rest } = payload;
  return apiRequest({
    apiUrl: `${UPDATE_ALLERGY()}/${id}`,
    method: "PUT",
    token: payload.token,
    payload: rest.values
  })
}

export const getAllergy = (payload) =>
  apiRequest({
    apiUrl: GET_ALLERGY(),
    method: "GET",
    token: payload.token,
  });


export const deleteAllergy = (payload) => {
  const { token, id } = payload;
  return apiRequest({
    apiUrl: `${DEL_ALLERGY()}/${id}`,
    method: "DELETE",
    token
  })
}


// Vaccinations apis
export const addVaccinations = (payload) => {
  const { token, ...rest } = payload;
  return apiRequest({
    apiUrl: ADD_VACCINATIONS(),
    method: "POST",
    token: payload.token,
    payload: rest.values
  })
}

export const updateVaccinations = (id, payload) => {
  const { token, ...rest } = payload;
  return apiRequest({
    apiUrl: `${UPDATE_VACCINATIONS()}/${id}`,
    method: "PUT",
    token: payload.token,
    payload: rest.values
  })
}

export const getVaccinations = (payload) =>
  apiRequest({
    apiUrl: GET_VACCINATIONS(),
    method: "GET",
    token: payload.token,
  });

export const deleteVaccinations = (payload) => {
  const { token, id } = payload;
  return apiRequest({
    apiUrl: `${DEL_VACCINATIONS()}/${id}`,
    method: "DELETE",
    token
  })
}

export const getPatientAppointment = (payload) => {
  const { status, token } = payload;
  let url = `${GET_PATIENT_APPOINTMENT_LIST()}?status=${status}`;
  return apiRequest({
    apiUrl: url,
    method: "GET",
    token: token,
  })
};

export const getDoctorlistApi = (payload) => {
  const user = getUser();
  let url = user === 'patient' ? GET_DOCTOR_LIST() : user === 'subadmin' ? GET_DOCTOR_LIST_FOR_SUBADMIN : GET_DOCTOR_LIST_FOR_ORGANIZATION
  return apiRequest({
    apiUrl: url,
    method: "GET",
    token: payload,
  })
};

export const qrcodeAPI = (payload) => {
  const url = `${QRCODE()}/encrypt-data?expiresIn=${payload.duration}`;
  console.log('payload.data_______', payload.data);
  return apiRequest({
    apiUrl: url,
    method: "POST",
    token: payload.token,
    payload: {
      ...payload.data, timeDetails: {
        timezone: 'UTC',
        duration: 'w',
        date: new Date()
      }
    }
  });
};

export const qrcodeDetailPageAPI = (payload, timedetails) => {
  console.log('timedetails____', timedetails);
  let payrole = `${QRPATIENTINFO}${payload}`;

  if (timedetails) {
    const queryString = new URLSearchParams(timedetails).toString();
    payrole += `&${queryString}`;
  }

  console.log('payrole_______', payrole);

  return apiRequestPublic({
    apiUrl: payrole,
    method: "GET",
  });
}



export const slotListAPI = (payload) => {
  const user = getUser();
  const url = user === 'patient' ? SLOTS() : SLOTS_BY_SUBADMIN;
  return apiRequest({
    apiUrl: `${url}${payload.id}&date=${payload.date}&type=${payload.type}`,
    method: "GET",
    token: payload.token
  });
}

export const createAppointmentApi = (payload) => {
  const user = getUser();
  const payrole = user === 'patient' ? `${CREATE_APPOINTMENT()}` : CREATE_APPOINTMENT_BY_SUBADMIN;
  return apiRequest({
    apiUrl: payrole,
    method: "POST",
    token: payload.token,
    payload: payload.data
  });
}
// invoice list
export const getInvoiceListApi = (payload) => {
  const user = getUser();
  let url = user === 'patient' ? BILLING_INVOICE() : user === 'doctor' ? BILLING_INVOICE_FOR_DOCTOR : user === 'organization' ? GET_INVOICES_BY_ORGANIZATION : GET_INVOICES_BY_SUBADMIN
  return apiRequest({
    apiUrl: url,
    method: "GET",
    token: payload.token,
  })
};
// single invoice
export const getInvoiceDetailApi = (payload) => {
  let url = `${BILLING_INVOICE_DETAIL()}?invoiceId=${payload.id}`;
  return apiRequest({
    apiUrl: url,
    method: "GET",
    token: payload.token,
  })
};

export const getDoctorAppointmentApi = (payload) => {
  const { status, token } = payload;
  let url = `${GET_APPOINTMENT_FOR_DOCTOR}?status=${status}`;
  return apiRequest({
    apiUrl: url,
    method: "GET",
    token: token,
  })
};

export const getPatientDetailsForDoctorApi = (payload) => {
  const user = getUser();
  const { id, token } = payload;
  let url = user === 'doctor' ? `${GET_PATIENT_DETAILS_FOR_DOCTOR}?id=${id}` : user === 'organization' ? `${GET_PATIENT_DETAILS_FOR_ORGANIZATION}?id=${id}` : `${GET_PATIENT_DETAILS_FOR_SUBADMIN}?id=${id}`
  return apiRequest({
    apiUrl: url,
    method: "GET",
    token: token,
  })
};
export const getDoctorDetailsForDoctorApi = (payload) => {
  const user = getUser();
  const { id, token } = payload;
  let url = user === 'doctor' ? `${GET_PATIENT_DETAILS_FOR_DOCTOR}?id=${id}` : user === 'organization' ? `${GET_DOCTOR_DETAILS_FOR_ORGANIZATION}?id=${id}` : `${GET_PATIENT_DETAILS_FOR_SUBADMIN}?id=${id}`
  return apiRequest({
    apiUrl: url,
    method: "GET",
    token: token,
  })
};
export const getSubadminDetailsForDoctorApi = (payload) => {
  const user = getUser();
  const { id, token } = payload;
  let url = user === 'doctor' ? `${GET_PATIENT_DETAILS_FOR_DOCTOR}?id=${id}` : user === 'organization' ? `${GET_SUBADMIN_DETAILS_FOR_ORGANIZATION}?id=${id}` : `${GET_PATIENT_DETAILS_FOR_SUBADMIN}?id=${id}`
  return apiRequest({
    apiUrl: url,
    method: "GET",
    token: token,
  })
};
export const getPatientPreviousAppointmentForDoctorApi = (payload) => {
  const user = getUser();
  let url = user === 'doctor' ? `${GET_PATIENT_PREVIOUS_APPOINTMENTS_FOR_DOCTOR}&appointmentId=${payload.appointmentId}&date=${payload.date}` :
    user === 'organization' ? `${GET_PATIENT_PREVIOUS_APPOINTMENTS_FOR_ORGANIZATION}&patientId=${payload.patientId}&date=${payload.date}` :
      `${GET_PATIENT_PREVIOUS_APPOINTMENTS_FOR_SUBADMIN}&patientId=${payload.patientId}&date=${payload.date}`;
  return apiRequest({
    apiUrl: url,
    method: "GET",
    token: payload.token,
  })
};


export const getSubscriptionDetails = (payload) => {
  return apiRequest({
    apiUrl: ORGANIZATION_SUBSCRIPTION_API,
    method: "POST",
    token: payload.token,
    payload: payload.data
  })
}


export const getDoctorAvailableTimeApi = (payload) => {
  const url = `${GET_DOCTOR_AVAILABLE_TIME}&date=${payload.date}`;
  return apiRequest({
    apiUrl: url,
    method: "GET",
    token: payload.token
  });
}
export const addSlotDoctorApi = (payload) => {
  const { token, data } = payload;
  return apiRequest({
    apiUrl: DOCTOR_ADD_SLOT,
    method: "POST",
    token: payload.token,
    payload: payload.data
  });
}
export const getSlotsByDoctorApi = (payload) => {
  const url = `${GET_SLOT_BY_DOCTOR}&duration=${payload?.duration?.toLowerCase()}&date=${payload.date}`;
  return apiRequest({
    apiUrl: url,
    method: "GET",
    token: payload.token
  });
}

export const deleteSlotsByDoctorApi = (payload) => {
  const url = `${DELETE_SLOT_BY_DOCTOR}slotId=${payload.slot_id}`;
  return apiRequest({
    apiUrl: url,
    method: "DELETE",
    token: payload.token
  });
}

export const getCurrencyApi = () => {
  return apiRequest({
    apiUrl: GET_CURRENCY,
    method: "GET",
    undefined,
    undefined,
    isPublic: true

  });
}

export const getMedicalHistoryAPI = (payload) => {
  const user = getUser();
  let url = user === 'patient' ? GET_MEDICAL_DETAILS_BY_PATIENT :
    user === 'doctor' ? `${GET_MEDICAL_DETAILS_BY_DOCTOR}&date=${payload.date}&appointmentId=${payload.appointmentId}` :
      user === 'organization' ? `${GET_MEDICAL_DETAILS_FOR_ORGANIZATION}&date=${payload.date}&patientId=${payload.patientId}` :
        `${GET_MEDICAL_DETAILS_FOR_SUBADMIN}&date=${payload.date}&patientId=${payload.patientId}`
  return apiRequest({
    apiUrl: url,
    method: "GET",
    token: payload.token
  });
}

export const completeAppointmentApi = (payload) =>
  apiRequest({
    apiUrl: COMPLETE_APPOINTMENT_BY_DOCTOR,
    method: "PUT",
    token: payload.token,
    payload: payload.data
  })

export const getSendMedicationApi = (payload) => {
  console.log("payload", payload)


  return apiRequest({
    apiUrl: SEND_MEDICATION_BY_DOCTOR,
    method: "POST",
    token: payload.token,
    payload: payload.payload
  })
}

export const getMedicineLists = (payload) => {
  console.log("payload", payload)

  const url = `${GET_MEDICINE_LIST_FOR_DOCTOR}?search=${payload.search}&limit=${payload.limit}&offset=${payload.offset}`;
  return apiRequest({
    apiUrl: url,
    method: "GET",
    token: payload.token
  });
}

export const cancelAppointmentByPatientApi = (payload) =>
  apiRequest({
    apiUrl: CANCEL_APPOINTMENT_BY_PATIENT,
    method: "PUT",
    token: payload.token,
    payload: payload.data
  })

export const confirmAppointmentApi = (payload) => {
  const { token, data } = payload;
  return apiRequest({
    apiUrl: CONFIRM_APPOINTMENT_BY_DOCTOR,
    method: "POST",
    token: token,
    payload: data
  });
}

export const patientCheckoutApi = (payload) => {
  console.log("payload", payload)

  return apiRequest({
    apiUrl: PATIENT_CHECKOUT,
    method: "POST",
    token: payload.token,
    payload: payload.data
  });
}
export const verifyPaymentPatientApi = (payload) => {
  const user = getUser();
  const url = user === 'organization' ? VERIFY_PAYMENT_ORGANIZATION : user === "patient" ? VERIFY_PAYMENT_PATIENT() : VERIFY_PAYMENT_SUBADMIN
  return apiRequest({
    apiUrl: url,
    method: "POST",
    token: payload.token,
    payload: payload.data
  })
}
export const getProfileByDoctorAPI = (payload) => {
  return apiRequest({
    apiUrl: GET_PROFILE_BY_DOCTOR,
    method: "GET",
    token: payload
  });
}
export const updateProfileByDoctorAPI = (payload) => {
  return apiRequest({
    apiUrl: UPDATE_PROFILE_BY_DOCTOR,
    method: "PUT",
    token: payload.token,
    payload: payload.data
  });
}

export const getOrganizationAppointmentListApi = (payload) => {
  const user = getUser();
  const { status, token } = payload;
  // let url = `${ORGANIZATION_GET_APPOINTMENTLIST}?status=${status}`;
  let url = user === 'organization' ? ORGANIZATION_GET_APPOINTMENTLIST : GET_OPD_APPOINTMENTLIST_BY_SUBADMIN
  return apiRequest({
    apiUrl: `${url}?status=${status}`,
    method: "GET",
    token: token,
  })
};

export const getPatientListApi = (payload) => {
  const user = getUser();
  let url = user === 'organization' ? GET_PATIENT_LIST : GET_PATIENT_LIST_BY_SUBADMIN
  return apiRequest({
    apiUrl: url,
    method: "GET",
    token: payload,
  })
};

export const getDoctorListForOrganizationApi = (payload) => {
  const user = getUser();
  let url = user === 'organization' ? GET_DOCTOR_LIST_FOR_ORGANIZATION : GET_DOCTOR_LIST_FOR_SUBADMIN
  return apiRequest({
    apiUrl: url,
    method: "GET",
    token: payload,
  })
};
export const getSubscriptionOrganizationApi = (payload) => {

  return apiRequest({
    apiUrl: ORGANIZATION_GET_SUBCRIPTION,
    method: "GET",
    token: payload.token,
  })
}
export const addDoctorApi = (payload) => {
  return apiRequest({
    apiUrl: ADD_DOCTOR,
    method: "POST",
    token: payload.token,
    payload: payload.data
  })
};

export const addSubAdminApi = (payload) => {
  return apiRequest({
    apiUrl: ADD_SUBADMIN,
    method: "POST",
    token: payload.token,
    payload: payload.data
  })
};

export const getProfileByOrganizationAPI = (payload) => {
  return apiRequest({
    apiUrl: GET_ORGANIZATION_PROFILE,
    method: "GET",
    token: payload
  });
}

export const updateProfileByOrganizationAPI = (payload) => {
  return apiRequest({
    apiUrl: UPDATE_PROFILE_BY_ORGANIZATION,
    method: "PUT",
    token: payload.token,
    payload: payload.data
  });
}

export const getSubadminListForOrganizationApi = (payload) => {
  return apiRequest({
    apiUrl: GET_SUBADMIN_LIST,
    method: "GET",
    token: payload,
  });
}

export const putUpdateStatusSubadmin = (payload, token) => {
  console.log("payload", payload)
  return apiRequest({
    apiUrl: ORGANIZATION_SUBADMIN_UPDATE_STATUS,
    method: "PUT",
    token: payload.token,
    payload: payload.payload
  })
}
export const putUpdateStatusdoctor = (payload, token) => {
  console.log("payload", payload)
  return apiRequest({
    apiUrl: ORGANIZATION_DOCTOR_UPDATE_STATUS,
    method: "PUT",
    token: payload.token,
    payload: payload.payload
  })
}
export const deletePatient = (payload, token) => {

  return apiRequest({
    apiUrl: ORGANIZATION_REMOVE_PATIENT,
    method: "PUT",
    token: payload.token,
    payload: payload.payload
  })
}
export const addPatientByIdApi = (payload) => {
  const { token, patientID } = payload
  return apiRequest({
    apiUrl: `${ADD_PATIENT_BY_ID}/${patientID}`,
    method: "PUT",
    token: token,
  })
};

export const addPatientByFormApi = (payload) => {
  const user = getUser();
  let url = user === 'organization' ? ADD_PATIENT_BY_FORM : ADD_PATIENT_BY_SUBADMIN
  return apiRequest({
    apiUrl: url,
    method: "POST",
    token: payload.token,
    payload: payload.data
  })
};
// export const getPatientDetailsApi = (payload)=>{
//   const {token,data}= payload
//   console.log("payload",payload)
//   return apiRequest({
//     apiurl:`${GET_PATIENT_DETAILS_FOR_ORGANIZATION}?id=${data}`,
//     method:"GET",
//     token:token,

//   })
// }
export const getProfileBySubadminApi = (payload) => {
  return apiRequest({
    apiUrl: `${GET_PROFILE_BY_SUBADMIN}`,
    method: "GET",
    token: payload
  })
};

export const getRoomsApi = (payload) => {
  return apiRequest({
    apiUrl: GET_ROOMS,
    method: "GET",
    token: payload
  })
};

export const addRoomApi = (payload, token) => {
  return apiRequest({
    apiUrl: ADD_ROOM,
    method: "POST",
    token,
    payload
  })
};

export const updateRoomApi = (payload, token) => {
  return apiRequest({
    apiUrl: UPDATE_ROOM,
    method: "PUT",
    token,
    payload
  })
};

export const admitPatientApi = (payload, token) => {
  return apiRequest({
    apiUrl: UPDATE_ROOM,
    method: "PUSH",
    token,
    payload
  })
};

export const admitPatientBySubadminApi = (payload, token) => {
  return apiRequest({
    apiUrl: ADMIT_PATIENT,
    method: "POST",
    token,
    payload
  })
};

export const addPatientServiceApi = (payload, token) => {
  return apiRequest({
    apiUrl: ADD_PATIENT_SERVICE,
    method: "POST",
    token,
    payload
  })
};

export const getAdmittedPatientApi = (payload) => {
  const { status, token } = payload;
  return apiRequest({
    apiUrl: `${GET_ADMITTED_PATIENT}status=${status}`,
    method: "GET",
    token,
  })
};

export const getAdmittedPatientServiceApi = (payload) => {
  const { admitPatientId, token } = payload;
  return apiRequest({
    apiUrl: `${GET_ADMITTED_PATIENT_SERVICE}${admitPatientId}`,
    method: "GET",
    token,
  })
};

export const getLatestECGAPI = (payload) => {
  return apiRequest({
    apiUrl: GET_LATEST_ECG(),
    method: "GET",
    token: payload.token,
  });
}

export const fileUpload = (url, file, token) => {
  return apiRequest({
    apiUrl: url,
    method: "POST",
    payload: file,
    token
  })
}


export const requestDeletePatientApi = (payload) => {
  return apiRequest({
    apiUrl: REQUEST_DELETE_PATIENT,
    method: "POST",
    token: payload.token,
    payload: payload.data
  });
};

export const verifyDeleteAccountApi = (payload) => {
  return apiRequest({
    apiUrl: VERIFY_DELETE_PATIENT,
    method: "POST",
    token: payload.token,
    payload: payload.data
  });
};

/**
 * Analyze blood report
 */
export const analyzeReportApi = ({ token, file }) => {
  const formData = new FormData();
  formData.append("report", file);

  return apiRequest({
    apiUrl: ANALYZE_REPORT,
    method: "POST",
    token,
    payload: formData
  });
}

/**
 * Fetch scanned reports list
 */
export const getScannedReportsApi = ({ token }) => {
  return apiRequest({
    apiUrl: GET_SCANNED_REPORTS,
    method: "GET",
    token
  });
};

/**
 * Get AI recommendations
 */
export const getRecommendationsApi = ({ token, data }) => {
  return apiRequest({
    apiUrl: GET_RECOMMENDATIONS,
    method: "POST",
    token,
    payload: data
  });
};

export const getAbnormalReportsApi = ({ token }) => {
  return apiRequest({
    apiUrl: GET_ABNORMAL_REPORTS,
    method: "GET",
    token
  });
};

export const getLastEcgApi = ({ token }) => {
  return apiRequest({
    apiUrl: GET_BLOOD_COUGH_IMAGE,
    method: "GET",
    token
  });
};

export const getDoctorAbnormalReportsApi = ({ token, appointmentId }) => {
  return apiRequest({
    apiUrl: `${GET_ABNORMAL_REPORTS_BY_DOCTOR}?appointmentId=${appointmentId}`,
    method: "GET",
    token
  });
};

export const getAbnormalReportsBySubadmin = ({ token, id }) => {
  return apiRequest({
    apiUrl: `${GET_ABNORMAL_REPORTS_BY_SUBADMIN}?id=${id}`,
    method: "GET",
    token
  });
};

export const getAbnormalReportsByOrg = ({ token, id }) => {
  return apiRequest({
    apiUrl: `${GET_ABNORMAL_REPORTS_BY_ORG}?id=${id}`,
    method: "GET",
    token
  });
};

export const sleepDataAPI = (payload) => {
  const user = getUser();
  let URL = user === 'patient' ?
    `${getUriWithDurationAndDateFormat(GET_SLEEP_DATA(), payload?.duration?.toLowerCase(), payload.date)}` : user === 'doctor' ?
      `${GET_PATIENT_STEPS_BY_DOCTOR}&appointmentId=${payload.appointmentId}&duration=${payload?.duration?.toLowerCase()}&date=${payload.date}` :
      // : user === 'organization' ?
      //   `${GET_PATIENT_SLEEP_ORGANIZATION}&patientId=${payload.patientId}&duration=${payload?.duration?.toLowerCase()}&date=${payload.date}` :
      //   `${GET_PATIENT_SLEEP_SUBADMIN}&patientId=${payload.patientId}&duration=${payload?.duration?.toLowerCase()}&date=${payload.date}`;
      `${getUriWithDurationAndDateFormat(GET_SLEEP_DATA(), payload?.duration?.toLowerCase(), payload.date)}`;
  if (payload.ai_analysis) {
    URL += `&ai_analysis=${payload.ai_analysis}`;
  }
  return apiRequest({
    apiUrl: URL,
    method: "GET",
    token: payload.token,
  });
};
export const getAllECGByDateApi = ({ token, date, page, limit, timezone }) => {
  return apiRequest({
    apiUrl: GET_ALL_ECG_BY_DATE,
    method: "GET",
    payload: { date, page, limit, timezone },
    token
  });
};
export const getDoctorPatientECGByDateApi = ({ token, appointmentId, date, page, limit, timezone }) => {
  return apiRequest({
    apiUrl: GET_DOCTOR_PATIENT_ECG_BY_DATE,
    method: "GET",
    payload: { appointmentId, date, page, limit, timezone },
    token
  });
};

export const getDoctorPatientLastEcgApi = ({ token, appointmentId }) => {
  return apiRequest({
    apiUrl: GET_DOCTOR_PATIENT_LAST_ECG,
    method: "GET",
    payload: { id: appointmentId },
    token
  });
};

// ========================> Family Member APIs <=========================

export const sendFamilyMemberRequestAPI = ({ token, emailOrPhone, relation }) =>
  apiRequest({
    apiUrl: FAMILY_MEMBER_REQUEST(),
    method: "POST",
    token,
    payload: { emailOrPhone, relation },
  });

export const respondFamilyMemberRequestAPI = ({ token, requestId, action }) =>
  apiRequest({
    apiUrl: FAMILY_MEMBER_REQUEST_RESPOND(requestId),
    method: "PUT",
    token,
    payload: { action },
  });

export const getMyFamilyMembersAPI = ({ token }) =>
  apiRequest({
    apiUrl: FAMILY_MEMBERS(),
    method: "GET",
    token,
  });

export const getIncomingFamilyRequestsAPI = ({ token }) =>
  apiRequest({
    apiUrl: FAMILY_MEMBER_INCOMING_REQUESTS(),
    method: "GET",
    token,
  });

export const getSentFamilyRequestsAPI = ({ token }) =>
  apiRequest({
    apiUrl: FAMILY_MEMBER_SENT_REQUESTS(),
    method: "GET",
    token,
  });

export const removeFamilyMemberAPI = ({ token, relationId }) =>
  apiRequest({
    apiUrl: FAMILY_MEMBER_REMOVE(relationId),
    method: "DELETE",
    token,
  });

export const getFamilyMemberDataAPI = ({ token, memberId, timezone, duration, date }) =>
  apiRequest({
    apiUrl: `${FAMILY_MEMBER_DATA(memberId)}?timezone=${timezone || 'UTC'}&duration=${duration || 'w'}&date=${date || new Date().toISOString().split('T')[0]}`,
    method: "GET",
    token,
  });